import Vue from 'vue'
import Page from './Page.vue'

Vue.component('Page', Page)
